"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubpaths = void 0;
const construct_1 = require("./helpers/construct");
const parse_path_1 = require("./parse-path");
const serialize_instructions_1 = require("./serialize-instructions");
/**
 * @description Splits a valid SVG path into it's parts.
 * @param {string} path A valid SVG path
 * @see [Documentation](https://remotion.dev/docs/paths/get-subpaths)
 */
const getSubpaths = (path) => {
    const parsed = (0, parse_path_1.parsePath)(path);
    const { segments } = (0, construct_1.constructFromInstructions)(parsed);
    return segments.map((seg) => {
        return (0, serialize_instructions_1.serializeInstructions)(seg);
    });
};
exports.getSubpaths = getSubpaths;
